import IconButtonBack from "components/IconButtonBack";
import { Typography, Box } from "@mui/material";
import ModalSM from "components/ModalSM";
import DivInline from "components/DivInline";
import Divider10 from "components/Divider10";
import moment from "moment";
export default function TimeHistoryDataModal({ open, json, handleClose, timeImg }) {
    delete json["_id"];
    const m = moment(json.timeStamp);
    if (!open) return null;
    return (
        <ModalSM height="80vh" open={open} onClose={handleClose}>
            <Box sx={{ padding: "0 2vw 0 2vw" }}>
                <DivInline alignItems="center">
                    <IconButtonBack onBtnClick={handleClose} />
                    {timeImg}
                    <Typography sx={{ marginLeft: "1vw" }}>{`[${json.commandCode.toString(16).padStart(4, "0")}]`}</Typography>
                    <Typography sx={{ marginLeft: "1vw" }}>{m.format("YYYY-MM-DD,HH:mm")}</Typography>
                </DivInline>
                <Divider10 />
                {Object.keys(json || {})
                    .sort((a, b) => a.localeCompare(b))
                    .map((field) => (
                        <DivInline justifyContent="space-between">
                            <Typography>{field}</Typography>
                            <Typography>{json[field]}</Typography>
                        </DivInline>
                    ))}
            </Box>
        </ModalSM>
    );
}